import Modal from 'core/components/dialogs/Modal'
import Button from 'core/components/buttons/Button'

interface PurpleAccessModalProps {
  show: boolean
  onClose: VoidFunction
  accessDate: string | null
}

const PurpleAccessModal = ({
  show,
  onClose,
  accessDate
}: PurpleAccessModalProps) => {
  return (
    <Modal
      show={show}
      title="Access required"
      footer={
        <Button variant="primary" onClick={onClose}>
          Close
        </Button>
      }
    >
      {accessDate ? (
        <p>
          Looks like you are not configured for access to this app until{' '}
          {accessDate}. Check back again on this date, or if you believe this is
          an error, give us a call at{' '}
          <Button
            variant="link"
            className="text-primary"
            onClick={() => {
              window.open('tel:8888016714', '_blank')
            }}
          >
            888–801–6714
          </Button>
          .
        </p>
      ) : (
        <>
          <p>Your employer has not subscribed to the Motus app at this time.</p>
          <br />
          <p>
            To request this configuration, please give us a call at{' '}
            <Button
              variant="link"
              className="text-primary"
              onClick={() => {
                window.open('tel:8888016714', '_blank')
              }}
            >
              888–801–6714
            </Button>{' '}
            or email us at{' '}
            <Button
              variant="link"
              className="text-primary"
              onClick={() => {
                window.open('mailto:memberservices@motus.com', '_blank')
              }}
            >
              memberservices@motus.com
            </Button>
            .
          </p>
          <br />
          <p>
            Go to{' '}
            <Button
              variant="link"
              className="text-primary"
              onClick={() => {
                window.open('https://motus.com', '_blank')
              }}
            >
              www.motus.com
            </Button>
            to log in to the mobile web version of your Motus account.
          </p>
        </>
      )}
    </Modal>
  )
}

export default PurpleAccessModal
